import list from "./list";
import multiBet from "./multi-bet";
const bettingCofigModule = {
  namespaced: true,
  modules: {
    list,
    multiBet,
  },
};

export default bettingCofigModule;
